import React, { useEffect, useState } from 'react';
import { random_icons } from './random_icons';
import ShakeImage from './ShakeImage';
import './Footer.scss';
// Define the types for your props here (if you have any)
interface FooterProps {
    // example: images: string[];
}

const Footer: React.FC<FooterProps> = () => {
    const number_of_images = 3;
    const [imageUrls, setImageUrls] = useState([]);
    // Logic to select random images
    // This could be an API call or a selection from a predefined list of images
    useEffect(() => {
        let temp = [];
        for (let i = 0; i < number_of_images; i++) {
            temp.push(random_icons[Math.floor(Math.random() * random_icons.length)]);
        }
        setImageUrls(temp);
    }, [])

    return (
        <footer className="playwatch-footer" style={{ position: 'relative' }}>
            {/* Render your random images here */}
            <div className="icon-container" style={{ position: 'relative', bottom: 10 }}>
                {/* Assuming you have an array of image URLs, map them into img tags */}
                {/* images.map(url => <img src={url} alt="Random" key={url} />) */}
                {imageUrls.map((imageUrl) => {
                    return <ShakeImage imageUrl={imageUrl} />
                })}
            </div>
            {/* Rest of the footer content */}
        </footer>
    );
};

export default Footer;
